import * as React from 'react';

// import styles from './index.less';

enum Direction {
  up = -90,
  right = 0,
  down = 90,
  left = 180,
}

interface FArrowProps {
  className?: string;
  style?: React.CSSProperties;
  direction?: 'up' | 'right' | 'down' | 'left';

  onClick?(): void;
}


function FArrow({ className, style, direction = 'right', ...props }: FArrowProps) {
  // console.log(Direction[direction], 'Direction[direction] isdjf;lksdjflkjlkj');
  return (<i
    className={['freelog', 'fl-icon-zhankaigengduo', className].join(' ')}
    style={{
      transform: `rotate(${Direction[direction]}deg)`,
      ...style,
    }}
    {...props}
  />);
}

export default FArrow;
